import { useState } from "react";
import { useReprocessFileAdminMutation } from "../../api/projectsApi";
import { IconColorE, IconSizeE, StatusE, UserRoleE } from "../../models/enums";
import { clss } from "../../utils/helpers/styleHelpers";
import AccessRights from "../AccessRights/AccessRights";
import Icon from "../Icon/Icon";

import styles from "./styles.module.scss";

type ReprocessIconT = {
  projectFileId: number;
  projectStatus: StatusE;
  mobile?: boolean;
};

const ReprocessIcon = ({
  projectFileId,
  projectStatus,
  mobile,
}: ReprocessIconT) => {
  const [reprocess] = useReprocessFileAdminMutation();
  const [disableReprocess, setDisableReprocess] = useState(false);

  const handleReprocess = async () => {
    setDisableReprocess(true);
    await reprocess({ projectFileId });
  };

  const accessProps = {
    accessFor: [
      UserRoleE.GlobalAdmin,
      UserRoleE.PostProduction,
      UserRoleE.DeliveryService,
    ],
    condition:
      projectStatus !== StatusE.Opened &&
      projectStatus !== StatusE.Deleted &&
      projectStatus !== StatusE.Cancelled,
  };
  
  const content = (
    <button
      className={clss([
        styles.reprocessIconWrapper,
        disableReprocess ? styles.rotateAnimation : "",
      ])}
      disabled={disableReprocess}
    >
      <Icon
        name="restart"
        color={IconColorE.GRAY}
        size={IconSizeE.S}
        title="Resend to processing"
        className={styles.reprocessIcon}
        onClick={handleReprocess}
      />
    </button>
  );

  if (mobile) {
    return (
      <AccessRights {...accessProps}>
        <div className={styles.reprocessIconWrapperMobile}>{content}</div>
      </AccessRights>
    );
  }

  return <AccessRights {...accessProps}>{content}</AccessRights>;
};

export default ReprocessIcon;
